import React from 'react'
import Pt from 'prop-types'
import { connect } from 'react-redux'
import { PageHeader } from 'react-bootstrap'
import { Link } from 'react-router'

import { SignupWithExternalsRecord } from 'internal-components/src/records'
import { selectSignupWithExternals } from 'internal-components/src/redux/modules/signup/selectors'
import {
  makeSelectError,
  makeSelectLoading,
} from 'internal-components/src/redux/modules/loading'

import * as signupActions from '../../redux/modules/signupEdit/actions'
import PageLoading from '../../components/Layout/PageLoading'
import SignupDetails from '../../components/SignupDetails'

export function SignupView({
  continueSignup,
  error,
  loading,
  signupWithExternals,
}) {
  if (error) {
    let title = 'An error has occurred.'
    let errorMessage = 'An error has occurred loading this signup.'

    if (error.status === 403) {
      title = 'Permission Denied'
      errorMessage = (
        <div>
          <p>
            You do not have permission to view this signup. You may have logged
            in with the wrong account.
          </p>

          <Link to="/logout">Logout</Link>
        </div>
      )
    }

    return (
      <section className="container">
        <PageHeader>{title}</PageHeader>

        {errorMessage}
      </section>
    )
  }

  if (
    loading ||
    !signupWithExternals ||
    !signupWithExternals.offer ||
    !signupWithExternals.product
  ) {
    return <PageLoading />
  }

  return (
    <section className="container">
      <PageHeader>Signup Details</PageHeader>

      <SignupDetails
        continueSignup={continueSignup}
        signupWithExternals={signupWithExternals}
      />
    </section>
  )
}

SignupView.propTypes = {
  continueSignup: Pt.func.isRequired,
  // eslint-disable-next-line
  error: Pt.object,
  loading: Pt.bool.isRequired,
  signupWithExternals: Pt.instanceOf(SignupWithExternalsRecord),
}

const mapStateToProps = () => {
  const selectLoading = makeSelectLoading()
  const selectSignupLoading = makeSelectLoading()
  const selectSignupError = makeSelectError()

  return (state, { params }) => ({
    error: selectSignupError(state, { type: 'signup', key: params.reference }),
    loading:
      selectLoading(state, { type: ['products', 'offers'] }) ||
      selectSignupLoading(state, { type: 'signup', keys: params.reference }),
    signupWithExternals: selectSignupWithExternals(state, {
      reference: params.reference,
    }),
  })
}

export default connect(
  mapStateToProps,
  signupActions,
)(SignupView)



// WEBPACK FOOTER //
// ./src/views/Signup/SignupView.jsx